<template lang="pug">
.AboutTeam
  section#team
    //- h2 WHO WE ARE
    //- h2 TEAM
    h2 TEAM
    h2 {{ $t('团队成员') }}
    .teams
      .teams__row.teams__row__1
        .teams__list
          template(
            v-for="val in teams.slice(0, 6)"
          )
            .teams__item(:class="[val.id]", :data-index="val.index")
              .teams__img__wrapper
                .teams__item__des
                  p {{ val[lang] }}
                  p {{ val.position }}
                img(:src="val.src")
      .teams__row.teams__row__2
        .teams__list
          template(v-for="val in teams.slice(6)")
            .teams__item(:class="[val.id]" :data-index="val.index")
              .teams__img__wrapper
                .teams__item__des
                  p {{ val[lang] }}
                  p {{ val.position }}
                img(:src="val.src")

  section#teams-modal
    img.teams-modal__close(src="./imgs/close-button.png")
    img.teams-modal__button.teams-modal__pre
    img.teams-modal__button.teams-modal__next
    .teams-modal__window
      .teams-modal__list
        template(
          v-for="item in teams"
        )
          .teams-modal__item(:class="[item.id]")
            .teams-modal__img__wrapper
              img(:src="item.src")
            .teams-modal__content__wrapper
              h3.teams-modal__title {{ item.name }}
              .teams-modal__table
                .teams-modal__position {{ item.position }}
                .teams-modal__join {{ "Join: " + item.join }}
                .teams-modal__sign {{ item.sign }}
                .teams-modal__skill {{"技能: " + item.skill}}
              .teams-modal__intro
                h4 自我介绍：
                p {{ item.intro }}
              .teams-modal__feeling
                h4 在复歌工作的感受：
                p {{ item.feeling }}
  .overlay
</template>
<script>
import db from '@/db'
var c1 = null
var c2 = null
function modal (index) {
  var teams = [
    'haidai',
    'guowei',
    'amber',
    'sujie',
    'sumingxuan',
    'ruantingting',
    'liumengyuan',
    'jidy',
    'wangjiadong',
    'wangfangyu',
    'yushuzhe'
  ]
  var modal = document.querySelector('#teams-modal')
  var overlay = document.querySelector('.overlay')
  // click overlay close modal
  overlay.addEventListener('click', function () {
    overlay.style.display = modal.style.display = 'none'
    modal.removeEventListener('click', handleModalPlay)
  })

  // close button
  modal.querySelector('.teams-modal__close').addEventListener('click', function () {
    overlay.style.display = modal.style.display = 'none'
    modal.removeEventListener('click', handleModalPlay)
  })

  // slide
  appendNode()
  overlay.style.display = modal.style.display = 'block'
  var wrapper = modal.querySelector('.teams-modal__window')
  var imgs = modal.querySelectorAll('.teams-modal__button')
  var list = wrapper.querySelector('.teams-modal__list')
  var items = wrapper.querySelectorAll('.teams-modal__item')
  var itemWidth = items[0].clientWidth
  list.style.transition = 'none'
  list.style.width = itemWidth * items.length + 'px'

  // first to show
  list.style.left = -itemWidth * (index + 1) + 'px'
  var distance = -itemWidth * (index + 1)
  setImg(index)

  // event
  modal.addEventListener('click', handleModalPlay)

  function handleModalPlay (e) {
    var target = e.target
    if (/next/.test(target.className)) {
      goNext()
    } else if (/pre/.test(target.className)) {
      goPre()
    }
  }

  function setImg (index) {
    var pre = teams[getPreIndex(index)]
    var next = teams[getNextIndex(index)]

    var arrPre = imgs[0].className.split(' ')
    arrPre[2] = pre
    imgs[0].className = arrPre.join(' ')

    var arrNext = imgs[1].className.split(' ')
    arrNext[2] = next
    imgs[1].className = arrNext.join(' ')

    imgs[0].src = require('./imgs/' + pre + '.jpg')
    imgs[1].src = require('./imgs/' + next + '.jpg')
  }

  function goNext () {
    index = getNextIndex(index)
    setImg(index)
    if (distance === -itemWidth * (items.length - 1)) {
      list.style.transition = 'none'
      distance = -itemWidth
      list.style.left = distance + 'px'
    }
    setTimeout(function () {
      list.style.transition = '0.5s'
      distance -= itemWidth
      list.style.left = distance + 'px'
    }, 200)
  }

  function goPre () {
    index = getPreIndex(index)
    setImg(index)
    if (distance === 0) {
      list.style.transition = 'none'
      distance = -itemWidth * (items.length - 2)
      list.style.left = distance + 'px'
    }
    setTimeout(function () {
      list.style.transition = '0.5s'
      distance += itemWidth
      list.style.left = distance + 'px'
    }, 200)
  }

  function getPreIndex (index) {
    return index === 0 ? teams.length - 1 : index - 1
  }

  function getNextIndex (index) {
    return index === teams.length - 1 ? 0 : index + 1
  }

  function appendNode () {
    var list = modal.querySelector('.teams-modal__list')
    if (list.childNodes.length > 12) return
    var first = list.firstElementChild.cloneNode(true)
    var last = list.lastElementChild.cloneNode(true)
    list.appendChild(first)
    list.insertBefore(last, list.firstElementChild)
  }
}

function Carousel (nodeName, interval, position) {
  appendNode.call(this)
  this.wrapper = document.querySelector(nodeName)
  this.list = this.wrapper.querySelector('.teams__list')
  this.items = this.wrapper.querySelectorAll('.teams__item')
  this.itemWidth = window.innerWidth * 0.33
  this.distance = 0

  Array.prototype.slice.call(this.items).forEach(function (item) {
    item.style.width = window.innerWidth * 0.33 + 'px'
    item.style.float = 'left'
  })
  this.list.style[position] = 0
  this.list.style.width = this.itemWidth * this.items.length + 'px'

  var self = this
  this.wrapper.addEventListener('mouseenter', function () {
    self.stopSlide()
  })
  this.wrapper.addEventListener('mouseleave', function () {
    c1.stopSlide()
    c2.stopSlide()
    setTimeout(function () {
      c1.autoSlide()
      c2.autoSlide()
    }, 200)
  })
  this.list.addEventListener('click', function (e) {
    var target = e.target.parentNode.parentNode
    if (/teams__item/.test(target.className)) modal(Number(target.dataset.index))
  })

  this.goNext = function () {
    var self = this
    if (this.distance <= -this.itemWidth * (this.items.length / 2)) {
      this.list.style.transition = 'none'
      this.list.style[position] = 0
      this.distance = 0
    }
    setTimeout(function () {
      self.list.style.transition = '1.5s'
      // self.list.style['transition-timing-function'] = 'cubic-bezier(1.000, 0.000, 0.000, 1.000) '
      self.distance -= self.itemWidth
      self.list.style[position] = self.distance + 'px'
    }, 200)
  }

  this.autoSlide = function () {
    var self = this
    this.timer = setInterval(function () {
      self.goNext()
    }, interval)
  }

  this.stopSlide = function () {
    clearInterval(this.timer)
  }

  function appendNode () {
    var list = document.querySelector(nodeName + ' .teams__list')
    var nodes = list.querySelectorAll('.teams__item')
    Array.prototype.slice.call(nodes).forEach(function (node) {
      list.appendChild(node.cloneNode(true))
    })
  }
}

function enableSlide () {
  if (!window.isIE) {
    c1.autoSlide()
    c2.autoSlide()
  }

  window.addEventListener('focus', function () {
    c1.autoSlide()
    c2.autoSlide()
  })

  window.addEventListener('blur', function () {
    c1.stopSlide()
    c2.stopSlide()
  })
}

export default {
  data () {
    return {
      teams: [{
        id: 'haidai',
        zh: '海带',
        en: 'Dai Hai',
        position: 'Chief Cat',
        join: '2016.7',
        sign: '金牛座',
        skill: '以两脚兽不能做到的姿势睡觉。',
        intro: '我是一只橘猫，据说橘猫中只有20%是小姑娘，所以我是小公举！',
        feeling: '总体来说呢，我应该是复歌的员工中工作最轻松的~我的工作内容主要就是养膘，偶尔会给他们提供吸猫，撸猫等减压的服务，虽然我的内心其实是拒绝的，但是看在小饼干的份上，勉强也是可以同意的~喵~',
        index: 0,
        src: require('./imgs/haidai.jpg')
      }, {
        id: 'guowei',
        zh: '郭为',
        en: 'Wei Guo',
        position: 'CEO & Founder',
        join: '2009.9',
        sign: '巨蟹座',
        skill: '打篮球，写博客，讲笑话，爱祖国。',
        intro: '尤其受法国公司和女客户喜欢，都是知识使然。之前一直在学物理，复旦本科，美国博士辍学。',
        feeling: '从小到大我都对处女座情有独钟，复歌的生日是9月22日。',
        index: 1,
        src: require('./imgs/guowei.jpg')
      }, {
        id: 'amber',
        zh: 'Amber',
        en: 'Amber Zhang',
        position: 'COO & Co-founder',
        join: '2009.9',
        sign: '狮子座',
        skill: '公司运营，Digital Marketing，卖萌，买包。',
        intro: '别叫我老板，老大或者辣妈，我还是个少女。',
        feeling: '成长是痛并快乐着的过程，这里快乐比较多。',
        index: 2,
        src: require('./imgs/amber.jpg')
      }, {
        id: 'sujie',
        zh: '苏杰',
        en: 'Jie Su',
        position: 'CTO',
        join: '2015.5',
        sign: '巨蟹座',
        skill: '种菜，种花，开手动挡，吹笛子。',
        intro: '热爱生活，热爱数据，热爱开车。',
        feeling: '我喜欢这里的氛围，因为可以有一群牛逼坏了的码农陪着我干活。',
        index: 3,
        src: require('./imgs/sujie.jpg')
      }, {
        id: 'sumingxuan',
        zh: '苏明轩',
        en: 'Mingxuan Su',
        position: 'Chief Engineer',
        join: '2011.5',
        sign: '天蝎座',
        skill: '嗑瓜子，鸡蛋里挑骨头，数字的加减乘除计，Code Cleanup And Refactoring。',
        intro: '生于中原，喜欢小葱大蒜，却又酷爱散文诗。伴着仙剑毕业于大东北，徘徊两广，终定上海。',
        feeling: '复歌，和自己的名字一样让人熟悉。这里，有兄弟姐妹，有师有友，如家，如亲人。这是一种已经习惯的生活。',
        index: 4,
        src: require('./imgs/sumingxuan.jpg')
      }, {
        id: 'ruantingting',
        zh: '阮婷婷',
        en: 'Tina Ruan',
        position: 'Senior Operation Manager',
        join: '2012.4',
        sign: '天秤座',
        skill: '点钞，打算盘，鉴赏电视剧。',
        intro: '一个特别正直的小业务员。',
        feeling: '快乐的时光永远都会觉得过得太快啦~',
        index: 5,
        src: require('./imgs/ruantingting.jpg')
      }, {
        id: 'liumengyuan',
        zh: '刘梦圆',
        en: 'Effie Liu',
        position: 'Operation Manager',
        join: '2012.6',
        sign: '射手座',
        skill: 'SEM&SEO技能以及吐槽技能已点亮。',
        intro: '根正苗红的好青年。',
        feeling: '有梦可以追，有钱可以赚，有槽可以吐，有猫可以撸~',
        index: 6,
        src: require('./imgs/liumengyuan.jpg')
      }, {
        id: 'jidy',
        zh: 'Jidy Lu',
        en: 'Dai Hai',
        position: 'Product Manager',
        join: '2016.5',
        sign: '狮子座',
        skill: '网站分析，文案，项目管理，吐槽，勾搭程序员。',
        intro: '我不是真的要搞事情，只是不说出来心里难受。',
        feeling: '“二进宫”的感觉真好，就是车速太快，能稳点更好。',
        index: 7,
        src: require('./imgs/jidy.jpg')
      }, {
        id: 'wangjiadong',
        zh: '王佳东',
        en: 'Tony Wang',
        position: 'Product Manager',
        join: '2015.12',
        sign: '摩羯座',
        skill: '晒太阳，捉迷藏。',
        intro: '一枚低调的铲屎官。',
        feeling: '这有一群自由奔放的灵魂，拼命工作，拼命开车，拼命闹腾，拼命发神经。',
        index: 8,
        src: require('./imgs/wangjiadong.jpg')
      }, {
        id: 'wangfangyu',
        zh: '王方玉',
        en: 'Fangyu Wang',
        position: 'Product Manager',
        join: '2016.4',
        sign: '双子座',
        skill: '“开车”。',
        intro: '放心，以我的车技不会翻！',
        feeling: '沉迷吸猫，无心工作。',
        index: 9,
        src: require('./imgs/wangfangyu.jpg')
      }, {
        id: 'yushuzhe',
        zh: '俞述哲',
        en: 'Shuzhe Yu',
        position: 'Software Engineer',
        join: '2014.11',
        sign: '天蝎座',
        skill: 'Java',
        intro: '矮胖，猥琐，技术宅，单身狗，以上全跟我不符。',
        feeling: '站稳扶好，有孩子的抱紧了，师傅们准备开车啦！',
        index: 10,
        src: require('./imgs/yushuzhe.jpg')
      }]
    }
  },
  mounted () {
    c1 = new Carousel('.teams__row__1', 2000, 'left')
    c2 = new Carousel('.teams__row__2', 2000, 'right')

    enableSlide()
  },
  computed: {
    lang () {
      return db.lang
    }
  }
}
</script>

<style lang="stylus">
#team
  padding: 100px 0

#team>h2
  font-size: 36px
  line-height: 1.42
  text-align: center
  color:#3fb4e1

.teams__row
  overflow: hidden
  position: relative
  padding: 35px 0
  height: 164px
  margin-top: 60px

.teams__list
  position: absolute

.teams__item
  position: relative
  height: 205px
  width: 33%

.teams__row__1 .teams__item
  transform: translateX(-55%)

.teams__row__2 .teams__item
  transform: translateX(25%)

.teams__img__wrapper
  padding: 0 20px
  background-color: #fff
  position: absolute
  z-index: 3

@keyframes bounceIn
  from, 20%, 40%, 60%, 80%, to
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000)
  0%
    transform: scale3d(1, 1, 1)
  20%
    transform: scale3d(1.1, 1.1, 1.1)
  40%
    transform: scale3d(.9, .9, .9)
  60%
    transform: scale3d(1.03, 1.03, 1.03)
  80%
    transform: scale3d(1, 1, 1)
  to
    transform: scale3d(1.1, 1.1, 1.1)

.teams__img__wrapper img:hover
  animation-name: bounceIn
  animation-duration: 0.5s
  transform: scale(1.1, 1.1)

.teams__item img
  cursor: pointer
  width: 159px
  border-radius: 50%
  border: 10px solid #00a0e5

.teams__item__des
  position: absolute
  bottom: 3px
  font-size: 18px
  text-align: right
  transform: translateX(-100%)

.teams__item__des p
  margin-top: 5px
  font-size: 12px

.teams__item__des p:nth-child(1)
  font-size: 20px

.teams__item:before
  content: ""
  z-index: 1
  width: 100%
  position: absolute
  border-top: dotted #000 1px
  top: 49%

.teams__item:after
  content: ""
  z-index: 5
  display: block
  width: 15px
  height: 15px
  background-color: #00a0e5
  border-radius: 50%
  position: absolute
  top: 45.5%
  left: -27%

#teams-modal
  display: none
  position: fixed
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  width: 820px
  height: 534.8px
  z-index: 10

.overlay
  display: none
  position: fixed
  top: 0
  bottom: 0
  left: 0
  right: 0
  background-color: rgba(0, 0, 0, 0.3)
  z-index: 9

.teams-modal__window
  overflow: hidden
  position: relative
  height: 100%
  width: 100%

.teams-modal__close
  cursor: pointer
  position: absolute
  width: 20px
  right: 10px
  top: 10px
  cursor: pointer
  z-index: 9

.teams-modal__button
  width: 85px
  height: 85px
  border-radius: 50%
  position: absolute
  top: 43%
  cursor: pointer
  z-index: 2

@keyframes gelatine
  from
    transform: scale(1, 1)
  25%
    transform: scale(0.9, 1.1)
  50%
    transform: scale(1.1, 0.9)
  75%
    transform: scale(0.95, 1.05)

.teams-modal__button:hover
  animation: gelatine 0.5s

.teams-modal__pre
  left: -60px

.teams-modal__next
  right: -60px

.teams-modal__list
  position: absolute
  left: 0

.teams-modal__item
  position: relative
  height: 534.8px
  width: 820px
  float: left
  display: flex
  justify-content: center

.teams-modal__img__wrapper
  width: 327px
  background-color: #49b7e2
  display: flex
  justify-content: center
  align-items: center

.teams-modal__img__wrapper img
  width: 230px
  height: 230px
  border-radius: 50%

.teams-modal__content__wrapper
  padding: 50px
  width: 431px
  background-color: #fff

.teams-modal__title
  font-size: 20px
  font-stretch: condensed
  text-align: left
  color: #4ab7e2

.teams-modal__table
  display: flex
  flex-wrap: wrap
  margin-top: 30px

.teams-modal__join__left
  width: 60px

.teams-modal__join__right
  display: flex
  flex-direction: column
  width: 64px

.teams-modal__table>div.teams-modal__position
  border-right: none
  width: 155px

.teams-modal__table>div.teams-modal__join
  border-right: none

.teams-modal__table>div
  text-align: center
  width: 125px
  display: flex
  justify-content: center
  align-items: center
  box-sizing: border-box
  padding: 20px 0
  border: 1px solid #979797

.teams-modal__table>div.teams-modal__skill
  width: 405px
  border-top: none
  line-height: 1.7

.teams-modal__intro h4
  font-weight: 600
  color: #4ab7e2
  margin-bottom: 20px

.teams-modal__intro
  margin-top: 30px
  font-size: 14px
  line-height: 1.4
  color: #5e5e5e

.teams-modal__feeling h4
  font-weight: 600
  color: #4ab7e2
  margin-bottom: 20px

.teams-modal__feeling
  margin-top: 30px
  font-size: 14px
  line-height: 1.4
  color: #5e5e5e

.amber
  .teams__item__img:after
    background-color: #31d0ac
  img
    border-color: #31d0ac
  .teams__item__des
    color: #31d0ac
  .teams-modal__img__wrapper
    background-color: #31d0ac

.sujie
  .teams__item__img:after
    background-color: #ea5506
  img
    border-color: #ea5506
  .teams__item__des
    color: #ea5506
  .teams-modal__img__wrapper
    background-color: #ea5506

.sumingxuan
  .teams__item__img:after
    background-color: #3d7ec1
  img
    border-color: #3d7ec1
  .teams__item__des
    color: #3d7ec1
  .teams-modal__img__wrapper
    background-color: #3d7ec1

.wangfangyu
  .teams__item__img:after
    background-color: #a8dae2
  img
    border-color: #a8dae2
  .teams__item__des
    color: #a8dae2
  .teams-modal__img__wrapper
    background-color: #a8dae2

.jidy
  .teams__item__img:after
    background-color: #4e89c9
  img
    border-color: #4e89c9
  .teams__item__des
    color: #4e89c9
  .teams-modal__img__wrapper
    background-color: #4e89c9

.huangxiao
  .teams__item__img:after
    background-color: #678fcd
  img
    border-color: #678fcd
  .teams__item__des
    color: #678fcd
  .teams-modal__img__wrapper
    background-color: #678fcd

.yushuzhe
  .teams__item__img:after
    background-color: #68c0ce
  img
    border-color: #68c0ce
  .teams__item__des
    color: #68c0ce
  .teams-modal__img__wrapper
    background-color: #68c0ce

.wangjiadong
  .teams__item__img:after
    background-color: #3f4e74
  img
    border-color: #3f4e74
  .teams__item__des
    color: #3f4e74
  .teams-modal__img__wrapper
    background-color: #3f4e74

.ruantingting
  .teams__item__img:after
    background-color: #e6b422
  img
    border-color: #e6b422
  .teams__item__des
    color: #e6b422
  .teams-modal__img__wrapper
    background-color: #e6b422

.liumengyuan
  .teams__item__img:after
    background-color: #ee7948
  img
    border-color: #ee7948
  .teams__item__des
    color: #ee7948
  .teams-modal__img__wrapper
    background-color: #ee7948

.gaojie
  .teams__item__img:after
    background-color: #68c0ce
  img
    border-color: #68c0ce
  .teams__item__des
    color: #68c0ce
  .teams-modal__img__wrapper
    background-color: #68c0ce

.guowei
  img
    border-color: #4ba9e3
  .teams__item__img:after
    background-color: #4ba9e3
  .teams__item__des
    color: #4ba9e3
  .teams-modal__img__wrapper
    background-color: #4ba9e3

.haidai
  img
    border-color: #f38e2e
  .teams__item__img:after
    background-color: #f38e2e
  .teams__item__des
    color: #f38e2e
  .teams-modal__img__wrapper
    background-color: #f38e2e

.dingxijin
  img
    border-color: #4ba9e3
  .teams__item__img:after
    background-color: #4ba9e3
  .teams__item__des
    color: #4ba9e3
  .teams-modal__img__wrapper
    background-color: #4ba9e3

#teams-modal
  > .haidai
    border 3px solid #f38e2e
  > .guowei
    border 3px solid #4ba9e3
  > .amber
    border 3px solid #31d0ac
  > .sujie
    border 3px solid #ea5506
  > .sumingxuan
    border 3px solid #3d7ec1
  > .ruantingting
    border 3px solid #e6b422
  > .liumengyuan
    border 3px solid #ee7948
  > .jidy
    border 3px solid #4e89c9
  > .wangjiadong
    border 3px solid #4ba9e3
  > .gaojie
    border 3px solid #68c0ce
  > .huangxiao
    border 3px solid #678fcd
  > .wangfangyu
    border 3px solid #a8dae2
  > .yushuzhe
    border 3px solid #68c0ce
  > .dingxijin
    border 3px solid #4ba9e3
</style>
